<script setup>
import { useI18n } from 'vue-i18n';
import messages from './messages';

defineProps({
  sender: { type: Object, default: null },
  group: { type: Object, required: true },
});
const { t } = useI18n({ useScope: 'local', messages });
</script>

<template>
  <div
    class="flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5 text-xs leading-5"
  >
    <span class="font-medium text-n-slate-12 break-words">
      {{ sender?.name || t('participant') }}
    </span>
    <span v-if="group.username" class="text-n-slate-11 break-all">
      {{ `@${group.username}` }}
    </span>
    <span v-if="(group.authorKind || group.author_kind) === 'chat'" class="text-n-slate-11">
      {{ t('chatAuthor') }}
    </span>
    <span v-if="group.editedAt || group.edited_at" class="text-n-slate-11">{{
      t('edited')
    }}</span>
  </div>
</template>
